import { getReduxStore } from './redux-host.js';
import { setHostInfoAction } from './host.js';
import { openModalAction, closeModalAction } from './modal.js';
export function openModal(modalId, zIndex) {
    getReduxStore().dispatch(openModalAction({ id: modalId, zIndex }));
}
export function closeModal(modalId) {
    getReduxStore().dispatch(closeModalAction({ id: modalId }));
}
export function setHostInfo(host) {
    getReduxStore().dispatch(setHostInfoAction(host));
}
//# sourceMappingURL=triggers.js.map